// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__NR4rZ","actions":"AuthForm_actions__olb9Z"};